import { IonCheckbox } from '@ionic/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Button from '../../components/actions/Button'
import useUser from '../../contexts/hooks/useUser'
import PublicWrapper from '../../wrappers/publicWrapper/PublicWrapper'

const PermissionForm: React.FC = () => {
	const history = useHistory()
	const { setUser, user } = useUser()

	const { t } = useTranslation('pages_permissionForm')

	const [permissionGiven, setPermissionGiven] = useState(false)
	const [termsAgreed, setTermsAgreed] = useState(false)

	useEffect(() => {
		if (!user) {
			history.replace('/')
		}
	}, [user, history])

	if (!user) return null

	const goForward = async () => {
		if (!user) return

		setUser({
			termsAccepted: true,
		})
		history.push(`/overview`)
	}

	// if (isAuthenticated) return // We disable onboarding because its trash and useless for now Ville & Tommi 3.10.2025

	return (
		<PublicWrapper id='permission-form'>
			<h1 className='mb-7'>{t('kiitos')}</h1>
			<p className='text-text-grey-200 dark:text-text-grey-100 mb-3 text-center'>{t('info1')}</p>
			<p className='text-text-grey-200 dark:text-text-grey-100 mb-3 text-center'>{t('info2')}</p>

			<div className='text-text-grey-200 dark:text-text-grey-100 text-center'>
				{t('read')}
				<a
					href={t('termsAndConditionsUrl')}
					className='contact-support text-brand-primary-100-light dark:text-brand-primary-100-dark'
				>
					{t('termsAndConditions')}
				</a>
				{t('and')}
				<a
					href={t('privacyPolicyUrl')}
					className='contact-support text-brand-primary-100-light dark:text-brand-primary-100-dark'
				>
					{t('privacyPolicy')}
				</a>
			</div>

			<div className='permission-checkbox-container'>
				<IonCheckbox
					className='dark:[--border-color:#3cb49f] dark:[--border-color-checked:#3cb49f] dark:[--checkbox-background-checked:#3cb49f] dark:[--checkbox-background:#144448] [--border-color:#52ae32] [--border-color-checked:#52ae32] [--checkbox-background-checked:#52ae32] [--checkbox-background:#cae3cc]'
					onIonChange={e => setPermissionGiven(e.detail.checked)}
					checked={permissionGiven}
				/>
				<span className='text-text-grey-200 dark:text-text-grey-100 text-start'>
					{t('annaLupa')}
				</span>
			</div>

			<div className='permission-checkbox-container'>
				<IonCheckbox
					className='dark:[--border-color:#3cb49f] dark:[--border-color-checked:#3cb49f] dark:[--checkbox-background-checked:#3cb49f] dark:[--checkbox-background:#144448] [--border-color:#52ae32] [--border-color-checked:#52ae32] [--checkbox-background-checked:#52ae32] [--checkbox-background:#cae3cc]'
					onIonChange={e => setTermsAgreed(e.detail.checked)}
					checked={termsAgreed}
				/>
				<span className='text-text-grey-200 dark:text-text-grey-100 text-start'>
					{t('agreeTerms')}
				</span>
			</div>

			<div className='permission-button-container'>
				<Button onClick={goForward} disabled={!permissionGiven || !termsAgreed}>
					{t('tallenna', { ns: 'common' })}
				</Button>
			</div>
		</PublicWrapper>
	)
}

export default PermissionForm
